import {
  warn,
  error,
} from './logger'

const config = {
  baseURL: undefined,
  apiList: undefined,
}

const URI_PROTOCOL = /^https?:/

function isFullUri(apiKey) {
  return /^\/\//.test(apiKey) || URI_PROTOCOL.test(apiKey)
}

function isRelativeUri(apiKey) {
  return apiKey.charAt(0) === '/'
}

function checkBaseURL(baseURL) {
  if (typeof baseURL !== 'string') {
    throw new Error(`[Http Exception] baseURL must be string, but now: ${baseURL}`)
  }

  if (baseURL.charAt(baseURL.length - 1) === '/') {
    throw Error('[Http Exception] baseURL should not end with "/"')
  }
}

function checkApiItem(apiItem, apiKey) {
  const prefix = `[Http Exception] ${apiKey}`

  if (typeof apiItem !== 'string') {
    throw new Error(`${prefix} should be a string`)
  }

  if (!isFullUri(apiItem) && apiItem.charAt(0) !== '/') {
    throw new Error(`${prefix} should be start with "/"`)
  }
}

function checkApiList(apiList) {
  if (typeof apiList !== 'object') {
    throw new Error(`[Http Exception] apiList must be a map, but now: ${typeof apiList}`)
  }

  for (const key in apiList) { // eslint-disable-line no-restricted-syntax
    if (apiList.hasOwnProperty(key)) { // eslint-disable-line no-prototype-builtins
      checkApiItem(apiList[key], key)
    }
  }
}

export function configure({ baseURL, apiList }) {
  if (baseURL) {
    checkBaseURL(baseURL)

    if (typeof config.baseURL !== 'undefined') {
      warn('[Http Warning] baseURL defined more than once')
    }
    config.baseURL = baseURL
  }

  if (apiList) {
    checkApiList(apiList)

    if (typeof config.apiList !== 'undefined') {
      warn('[Http Warning] apiList defined more than once')
    }
    config.apiList = apiList
  }
}

/* --------------------- */

function concatBaseURL(apiUri, options) {
  if (options.baseURL) {
    return `${options.baseURL}${apiUri}`
  }
  if (typeof config.baseURL === 'undefined') {
    return apiUri
  }
  return config.baseURL + apiUri
}

function concatPath(apiUri, path) {
  // TODO: add check to remove redundant slash
  //
  return `${apiUri}/${path}`
}

const REG_PLACEHOLDER = /\$?\{([^}]+)\}/g

function replacePlaceholder(targetString, data = {}, params = {}) {
  const dataIsMap = data && typeof data.get === 'function' && typeof data.has === 'function'

  return targetString.replace(REG_PLACEHOLDER, (matched, key) => {
    if (params && params[key]) {
      return params[key]
    } if (data && data[key]) {
      return data[key]
    } if (dataIsMap && data.has(key)) {
      return data.get(key)
    }

    error(`[Http Exception] could not found placeholder ${key} in ${targetString} from payload`)
    return 'undefined'
  })
}

function handleUriCreation(apiStr, options) {
  let apiUri = isFullUri(apiStr) ? apiStr : concatBaseURL(apiStr, options)

  if (options.resourceParams) {
    apiUri = replacePlaceholder(apiUri, options.resourceParams)
  } else {
    apiUri = replacePlaceholder(apiUri, options.data, options.params)
  }

  if (options.resourceId) {
    apiUri = concatPath(apiUri, options.resourceId)
  }

  if (options.resourceAction) {
    apiUri = concatPath(apiUri, options.resourceAction)
  }

  return apiUri
}

export function makeUri(apiKey, options = {}) {
  if (isFullUri(apiKey) || isRelativeUri(apiKey) || typeof config.apiList === 'undefined') {
    return handleUriCreation(apiKey, options)
  } if (config.apiList[apiKey]) {
    return handleUriCreation(config.apiList[apiKey], options)
  }

  throw new Error(`[Http Exception] ${apiKey} is not specified on api-list.config`)
}

export function getMatchedPath(apiKey) {
  if (typeof config.apiList === 'undefined' || !config.apiList[apiKey]) {
    return apiKey
  }
  return config.apiList[apiKey]
}
